import { EnvType } from "../services";
import { IApiClient } from "../api-client";
import { UploadFileResponse } from "../Types/upload-file-response";

interface IUploadApiClient {
  UploadBrowserFile(
    formData: FormData,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<UploadFileResponse>;
}
export default class UploadApiClient implements IUploadApiClient {
  readonly servicePort = 9526;
  readonly serviceBaseUrl = "upload-service/api";

  uploadApiClient: IApiClient;

  constructor(uploadApiClient: IApiClient, envType: EnvType) {
    this.uploadApiClient = uploadApiClient;
    if (envType === "local") this.uploadApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }

  async UploadBrowserFile(
    formData: FormData,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<UploadFileResponse> {
    return await this.uploadApiClient.postUploadFormData(
      `${this.serviceBaseUrl}/upload`,
      formData,
      abortSignal,
      onUploadProgressCallback
    );
  }

  //------Utils------
  GetApiUrl(): string {
    return this.uploadApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
